import Vue from 'vue'
import AIAssistant from '@klook/admin-ai-assistant'
// 依赖 body.ai-chat-open class 让 antd-vue drawer/notification/modal 避让 AI 面板宽度；
// class 由下面 syncAIChatBodyClass 维护
import '@klook/admin-ai-assistant/compat'
import { registerAllRoutes } from '@klook/admin-ai-workflow-contracts'
import { registerWorkflows } from './workflows'
import { registerPersistentTools } from './persistent-tools'
import { isMerchant } from '@/env'

export function registerAIAssistant(ctx) {
  Vue.use(AIAssistant, {
    platform: isMerchant ? 'merchant' : 'admin',
    // 显式传当前语言。SDK 不传时只读 localStorage.language，而本站的语言取自
    // URL 首段（registerI18n 的 getLocale），两者可能不一致，面板 UI 文案就会串档。
    // registerI18n 先于本函数执行，ctx.i18n.locale 即 getLocale() 的结果。
    language: ctx.i18n && ctx.i18n.locale,
    // iframe 内无法通过组件实例访问 Vue.prototype.$router（getter 须实例触发），
    // 必须显式注入给 toolkit.navigate / builtin redirect-router
    getRouter: () => ctx.router
  })

  registerAllRoutes(Vue.prototype.$ai)
  registerWorkflows(Vue.prototype.$ai)
  registerPersistentTools(Vue.prototype.$ai)

  syncAIChatBodyClass(Vue.prototype.$ai)
}

/** 面板宽度过渡时长，与 SDK 的 .ai-panel / .ai-content-shrink 保持一致 */
const PANEL_TRANSITION_MS = 320

/**
 * 监听 AI Chat 面板开合状态，同步 body class 并派发 resize 事件。
 *
 * @param {import('@klook/admin-ai-assistant').AIInstance} ai
 */
function syncAIChatBodyClass(ai) {
  if (typeof document === 'undefined' || !ai || !ai.store) return

  const BODY_CLASS = 'ai-chat-open'

  // 借 new Vue() 空实例当 $watch 工厂，观察 ai.store.state（Vue.observable）
  const watcher = new Vue({
    computed: {
      isOpen() {
        return ai.store.state.isOpen
      }
    },
    watch: {
      isOpen: {
        immediate: true,
        handler(open) {
          document.body.classList.toggle(BODY_CLASS, !!open)
          // 等面板宽度过渡走完（320ms）再派 resize：rAF 只隔一帧，
          // 依赖 clientWidth 的组件（ECharts、虚拟列表等）量到的还是过渡起点的宽度。
          // 拖拽把手过程中的实时 resize 由 SDK 自己按 100ms 节流派发，这里不重复。
          if (typeof window !== 'undefined') {
            window.setTimeout(() => {
              window.dispatchEvent(new Event('resize'))
            }, PANEL_TRANSITION_MS + 20)
          }
        }
      }
    }
  })

  return watcher
}
